import { render, staticRenderFns } from "./InboxFriend.vue?vue&type=template&id=92a47220"
import script from "./InboxFriend.vue?vue&type=script&lang=js"
export * from "./InboxFriend.vue?vue&type=script&lang=js"
import style0 from "./InboxFriend.vue?vue&type=style&index=0&id=92a47220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports